import { cn } from "@/lib/cn";

type Props = {
  children: React.ReactNode;
  className?: string;
  as?: "div" | "section" | "header" | "footer" | "main";
};

export default function Container({ children, className, as = "div" }: Props) {
  const Tag = as;
  return (
    <Tag className={cn("mx-auto w-full max-w-[82rem] px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </Tag>
  );
}
